<div class="float-right d-none d-sm-block"><b>Version</b> 2.2</div>
<strong>
    <span>Copyright &copy; {{ currentYear }}</span>
  <span> Julian Yong Hao</span>
    <span>.</span>
</strong>
<span> All rights reserved.</span>
